import { render } from "./trademark.vue?vue&type=template&id=f2f1e8ca&scoped=true"
import script from "./trademark.vue?vue&type=script&lang=js"
export * from "./trademark.vue?vue&type=script&lang=js"

import "./trademark.vue?vue&type=style&index=0&id=f2f1e8ca&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f1e8ca"]])

export default __exports__